import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import * as Sentry from '@sentry/browser';
import GoogleAnalytics from 'react-ga';

import store from '../state/store';

import ProtectedRoute from '../hocs/ProtectedRoute';
import ApplicationLayout from '../layouts/ApplicationLayout';
import AuthenticationLayout from '../layouts/AuthenticationLayout';

const isProduction = process.env.NODE_ENV === 'production';

Sentry.init({
  dsn: 'https://96b8e799ac2f46f5a00a9cfb9e0c1b06@sentry.io/1392587',
  environment: isProduction ? 'production' : 'development',
});

function App() {
  if (isProduction) {
    GoogleAnalytics.initialize('UA-121617303-1');
  }

  return (
    <Provider store={store}>
      <BrowserRouter>
        <Switch>
          <ProtectedRoute exact path="/" component={ApplicationLayout} />
          <Route exact path="/login" component={AuthenticationLayout} />
        </Switch>
      </BrowserRouter>
    </Provider>
  );
}

export default App;
